// extracted by mini-css-extract-plugin
export var brand = "_2c-9";
export var button = "_2c-0";
export var chevron = "_2c-v";
export var chevronButton = "_2c-w";
export var content = "_2c-n";
export var danger = "_2c-g";
export var dangerOutlined = "_2c-h";
export var dark = "_2c-l";
export var darkTheme = "_2c-c";
export var extraSmall = "_2c-4";
export var fullWidth = "_2c-8";
export var ghost = "_2c-d";
export var gray = "_2c-t";
export var icon = "_2c-p";
export var iconButton = "_2c-s";
export var iconButtonBorder = "_2c-x";
export var iconButtonBorderDark = "_2c-y";
export var iconButtonBorderLight = "_2c-z";
export var iconLeft = "_2c-q";
export var iconRight = "_2c-r";
export var large = "_2c-1";
export var light = "_2c-m";
export var medium = "_2c-2";
export var micro = "_2c-5";
export var nano = "_2c-7";
export var outlined = "_2c-k";
export var pending = "_2c-a";
export var primary = "_2c-i";
export var shadow = "_2c-o";
export var small = "_2c-3";
export var solidLight = "_2c-e";
export var solidLightBrand = "_2c-f";
export var spinner = "_2c-u";
export var transparent = "_2c-j";
export var warning = "_2c-b";
export var wideNano = "_2c-6";